import type { FormProps } from '@/components/Form/form';
import Form from '@/components/Form/form';
import OrderStepProvider from '@/providers/OrderStepContext';
import classNames from 'classnames';
import { Suspense } from 'react';

import classes from './EmbeddedForm.module.scss';

export type EmbeddedFormProps = FormProps & {
  faqVariant?: boolean;
};

const EmbeddedForm: React.FC<EmbeddedFormProps> = (props) => {
  return (
    <OrderStepProvider>
      <div
        className={classNames(classes.embeddedForm, { [classes.faqVariant!]: props.faqVariant })}
        id={`form-${props.blok.id}`}
      >
        <Suspense>
          <Form {...props} embedded={true} trackFormPurchase={props.trackFormPurchase} />
        </Suspense>
      </div>
    </OrderStepProvider>
  );
};

export default EmbeddedForm;
